import { type FunctionComponent } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Outlet,
  Route,
  RouterProvider,
} from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute/ProtectedRoute';
import { useContainer } from './hooks/useContainer';
import { useSelector } from './hooks/useSelector';
import { LoginPage } from './pages/LoginPage/LoginPage';
import { LogoutPage } from './pages/LogoutPage/LogoutPage';
import { PrayerStreamPage } from './pages/PrayerStreamPage/PrayerStreamPage';
import { RootPage } from './pages/RootPage/RootPage';
import { ErrorBoundaryProvider } from './providers/ErrorBoundaryProvider/ErrorBoundaryProvider';
import { AppRoute } from './routes';
import { SettingsService } from './services/settings';

export const App: FunctionComponent = () => {
  const { contactUid, loggedIn, name } = useSelector((state) => state.auth);
  const { settings } = useContainer().get(SettingsService);

  const stream = useSelector((state) => state.stream);
  const { getPrayerStreamUserRegistration } = useSelector(
    (state) => state.asyncAction,
  );

  if (settings.simulateCrashOnLoad) {
    throw new Error('Simulated crash during application loading');
  }

  const prayerStreamUserRegistrationLoaded =
    getPrayerStreamUserRegistration.status !== null;

  const dataLoaded = (() => {
    if (!contactUid) {
      return false;
    }
    if (!name) {
      return false;
    }
    if (!prayerStreamUserRegistrationLoaded) {
      return false;
    }
    return true;
  })();

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route
          element={
            <ErrorBoundaryProvider boundaryName="createRoutesFromElements">
              <ProtectedRoute
                dataLoaded={dataLoaded}
                loggedIn={loggedIn}
                stream={stream}
              >
                <Outlet />
              </ProtectedRoute>
            </ErrorBoundaryProvider>
          }
        >
          <Route
            element={<Navigate replace to="/" />}
            path={AppRoute['/login/callback']}
          />

          <Route element={<LoginPage />} path={AppRoute['/login']} />
          <Route element={<LogoutPage />} path={AppRoute['/logout']} />

          <Route element={<PrayerStreamPage />} path={AppRoute['/chat']} />
          <Route element={<RootPage />} path="/" />
        </Route>

        {/* Redirects... */}

        {/* <Route Component={NotFoundPage} path="*" /> */}
      </>,
    ),
  );
  return <RouterProvider router={router} />;
};
